import { gql } from '@grandvisionhq/graphql';

var recentOrdersResultsFragment = gql`
  fragment RecentOrderResultsFragment on Order {
    orderNumber
    orderDate
    paymentStatus
    lineItems {
      ... on OrderLineItemPrescriptionGlass {
        mainLineItem {
          product {
            sku
            name {
              value
            }
            mainImage
          }
        }
      }
      ... on OrderLineItemNonPrescriptionBundle {
        mainLineItem {
          product {
            sku
            name {
              value
            }
            mainImage
          }
        }
      }
      ... on OrderLineItemBundle {
        product {
          sku
          name {
            value
          }
          mainImage
        }
      }
      ... on OrderLineItemContactLens {
        product {
          sku
          name {
            value
          }
          mainImage
        }
      }
      ... on OrderLineItemRegular {
        product {
          sku
          name {
            value
          }
          mainImage
        }
      }
      ... on OrderLineItemSolution {
        product {
          sku
          name {
            value
          }
          mainImage
        }
      }
      ... on OrderLineItemSubscription {
        subscriptionLineItems {
          ... on OrderLineItemContactLens {
            product {
              sku
              name {
                value
              }
              mainImage
            }
          }
          ... on OrderLineItemSolution {
            product {
              sku
              name {
                value
              }
              mainImage
            }
          }
        }
      }
    }
  }
`;

export { recentOrdersResultsFragment as default };
//# sourceMappingURL=recent-orders.js.map
